import Sticky from './Sticky.vue';
import withInstall from '@/shared/withInstall';

export const XSticky = withInstall(Sticky);
export default XSticky;
